goog.provide('el8.appchart.dialog.schedulePLRMassImport');

goog.require('el8.template.appchart.dialog.schedulePLRMassImport');
goog.require('el8.uiwidget.NewDialog');

el8.appchart.dialog.schedulePLRMassImport = (function() {

    var plrNotification = null;
    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'close', 'Dismiss', function() {
            that.hide();
        }, false
    );

    var that = new el8.uiwidget.NewDialog({
        title: 'Signing and Importing PLR Documents',
        modal: true,
        showXButton: false,
        height: 250,
        width: 520,
        buttonSet: buttonSet
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that._bindTriggers();
    };

    that._bindTriggers = function() {
        that.getContentElt().on('click', '.done-okay-trigger',  function(e) {
            that._plrNotification.refresh();
            el8.appchart.mainFeeds.chart.doCareteamSearch();
            that.hide();
        });
    };

    var super_show = that.show;
    that.show = function() {
        super_show.call(that);

        // setting content of the import dialog instead of doing it in contentFn,
        // in case we trigger show more than once
        that._contentElt.html(el8.template.appchart.dialog.schedulePLRMassImport.content());

        var successCb = function (data) {
            that._contentElt.html(el8.template.appchart.dialog.schedulePLRMassImport.done({
                itemsImported: data['items_imported']
            }));
        };

        var feedItemIds = that._plrNotification.getLastReviewFeedItemIds();

        $.el8_longPoll({
            url: el8.service.urls.get('schedulePLRMassImport'),
            data: JSON.stringify({ ids: feedItemIds }),
            success: successCb,
            error: function(data) {
                el8.appservice.notifier.clear();
                el8.uiwidget.alert(el8.util.consts.DEFAULT_ERROR_MSG);
            }
        });
    };

    that.setPLRNotification = function(plrNotification) {
        that._plrNotification = plrNotification;
    };

    return that;

})();
